import config from "@/config";
import http from "@/utils/request";

export default {
	newsCategory: {
		list: {
			url: `${config.API_URL}/admin/news_category/getList`,
			name: "获取资讯分类列表",
			get: async function (params = {}) {
				return await http.get(this.url, params);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/news_category/detail`,
			name: "获取资讯分类详情",
			get: async function (params = {}) {
				return await http.get(this.url, params);
			},
		},
		create: {
			url: `${config.API_URL}/admin/news_category/create`,
			name: "创建资讯分类",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		update: {
			url: `${config.API_URL}/admin/news_category/update`,
			name: "更新资讯分类",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/news_category/delete`,
			name: "删除资讯分类",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		batchDelete: {
			url: `${config.API_URL}/admin/news_category/batchDelete`,
			name: "批量删除资讯分类",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
	},
	news: {
		list: {
			url: `${config.API_URL}/admin/news/getList`,
			name: "获取资讯列表",
			get: async function (params = {}) {
				return await http.get(this.url, params);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/news/detail`,
			name: "获取资讯详情",
			get: async function (params = {}) {
				return await http.get(this.url, params);
			},
		},
		create: {
			url: `${config.API_URL}/admin/news/create`,
			name: "创建资讯",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		update: {
			url: `${config.API_URL}/admin/news/update`,
			name: "更新资讯",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/news/delete`,
			name: "删除资讯",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		batchDelete: {
			url: `${config.API_URL}/admin/news/batchDelete`,
			name: "批量删除资讯",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
	},
};
